import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { useSelector, useDispatch } from "react-redux";
import { setUserData } from "../../redux/user";
import SimpleTabs from "../../components/Tabs/SimpleTabs";
import HomeTab from "../../components/HomeTab/index";
import RegulamentationTab from "../Regulamentation/RegulamentationTab";
import WinnersTab from "../Winners/WinnersTab";
import LuckyNumbersTab from "../LuckyNumbersTab/LuckyNumbersTab";
import FAQTab from "../FAQ/FAQ";
import avantiicon from "../../assets/avantiicon.png";
import quitIcon from "../../assets/quitIcon.png";

import logoSocioIcon from "../../assets/avantiicon.png";
import DefaultPopup from "../../components/DefaultPopup/DefaultPopup";

import { PLANS } from "../../utils/consts";
import { useNavigate } from "react-router-dom";

const Home = (props) => {
  const [newTabName, setNewTabName] = useState(null);
  const { userData } = useSelector((state) => state.user);
  const { config } = useSelector((state) => state.global);
  const { dataHelper } = config;
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const [allFAQList, setAllFAQList] = useState([]);
  const [filteredFAQList, setFilteredFAQList] = useState([]);
  const disableCanLogin = useSelector((state) => state.global?.disableCanLogin);
  
  const open = () => {
    config?.popup?.setIsOpen(true);
    config?.popup?.setContent(
      <DefaultPopup
        img={logoSocioIcon}
        title="Em breve!"
        disclaimer="Fique atento! Em breve você vai poder logar e ter acesso à benefícios
        exclusivos"
      />
    );
  };

  const leftComponent = () => (
    <div className="avantiicon">
      <img src={avantiicon} alt="avantiicon" />
    </div>
  );
  const rightComponent = () => {
    const isUserDataEmpty = !userData || Object.keys(userData).length === 0;

    return (
      <>
      {isUserDataEmpty ? (
        <div className="enter">
        <a
          href={disableCanLogin ? "#" : "/login"}
          onClick={(e) => {
          if (disableCanLogin) {
            e.preventDefault();
            open();
          }
          }}
        >
          ENTRAR
        </a>
        </div>
      ) : (
        <>
        <div className="user-container">
          <div className="userData-container">
          {PLANS[userData?.LoyaltyCategory__c] && (
            <img
            className="img-profile-avanti"
            src={PLANS[userData?.LoyaltyCategory__c]}
            alt="user"
            />
          )}
          <div className="user-info">
            <span className="loyalty-txt">
            {userData.LoyaltyCategory__c}
            </span>
            <div className="user-txt-wrapper">
            <span className="user-txt">{`${userData.FirstName} ${userData.LastName}`}</span>
            </div>
          </div>
          </div>
          <div className="quit-container">
          <a href={"/logout"} className="quit-container">
            <span className="quit-txt">Sair</span>
            <img src={quitIcon} alt="icone sair" className="quit-icon" />
          </a>
          </div>
        </div>
        </>
      )}
      </>
    );
  };

  const onChangeTab = (newTabName) => {
    setNewTabName(newTabName);
  };

  const onKnowledgeListUpdate = (docs) => {
    const data = dataHelper.getList(docs);
    const FAQItemList = data
      .filter((item) => item?.Category__c !== undefined)
      .reduce((acc, curr) => {
        const Topic = curr?.Category__c;
        const obj = {
          question: curr?.Question__c,
          answer: curr?.Answer__c,
          isTest: curr?.PublishStatus__c === "Test",
        };
        if (acc[Topic]) {
          acc[Topic].push(obj);
        } else {
          acc[Topic] = [obj];
        }

        return acc;
      }, {});

    const returnDataFAQ = Object.keys(FAQItemList)
      .map((topic) => {
        const faqItem = FAQItemList[topic] || [];

        return {
          topic,
          faqItem,
        };
      })
      .sort((a, b) => {
        if (a?.topic < b?.topic) return -1;
        if (a?.topic > b?.topic) return 1;
        return 0;
      });

    setAllFAQList(returnDataFAQ);
    setFilteredFAQList(returnDataFAQ);
  };

  useEffect(() => {
    let unsubT;
    const getItems = async () => {
      unsubT = await dataHelper.getKnowledges((list) => {
        onKnowledgeListUpdate(list);
      });

      return unsubT;
    };

    getItems();

    return () => {
     if(unsubT)
      Object?.values(unsubT)?.forEach((unsub) => unsub());
    };
  }, [dataHelper]);

  return (
    <Container>
      <SimpleTabs
        leftComponent={leftComponent}
        rightComponent={rightComponent}
        newTabName={newTabName}
        setNewTabName={setNewTabName}
        drawerIsOpen={drawerIsOpen}
        setDrawerIsOpen={setDrawerIsOpen}
        userData={userData}
        canLogin={!disableCanLogin}
      >
        <HomeTab tablabel="Início" onChangeTab={onChangeTab} />
        <RegulamentationTab tablabel="Regulamento" />
        <WinnersTab tablabel="Ganhadores" onChangeTab={onChangeTab} />
        {userData && Object.keys(userData).length > 0 && (
          <LuckyNumbersTab tablabel="Meus Números" onChangeTab={onChangeTab} />
        )}
        <FAQTab
          tablabel="FAQ"
          hide={!allFAQList || allFAQList?.length === 0}
          allFAQList={allFAQList}
          setAllFAQList={setAllFAQList}
          filteredFAQList={filteredFAQList}
          setFilteredFAQList={setFilteredFAQList}
        />
      </SimpleTabs>
    </Container>
  );
};

export const Container = styled.div`
  position: relative;
  width: 100vw;
  min-height: 100vh;
  background-color: #006437;

  .content-tabs {
    align-items: center;
    background-color: rgba(0, 59, 33, 1);
    /* height: 84px; */
    padding: 16px 24px;
    flex: 1;
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 9999;
    
    > div.content-tabs-itens {
      display: flex;
      align-items: center;
      flex: 1;
      

      a.tabs-item {
        cursor: pointer;
        padding: 16px;

        &:hover {
          transform: scale(1.02);
        }
     
      }
    
    }
  }

  .avantiicon {
    margin-right: 16px !important;

    img {
      width: 118px;
      height: 36px;
    }
    @media (max-width: 768px) {
      align-self: flex-start;
      width: 94px;
      height: 28px;
    }
  }

  div.enter {
    display: flex;
    align-self: center !important;
    

    a {
      padding: 10px 20px;
      border-radius: 8px;
      background-color: rgba(218, 231, 83, 1) !important;
      color: rgba(0, 100, 55, 1);
      font-family: Roboto;
      font-weight: 700;
      font-size: 18px;
      line-height: 21.09px;
      letter-spacing: 0%;
    }

    button {
      padding: 10px 20px;
      border-radius: 8px;
      background-color: rgba(218, 231, 83, 1) !important;
      color: rgba(0, 100, 55, 1);
      font-family: Roboto;
      font-weight: 700;
      font-size: 18px;
      line-height: 21.09px;
      letter-spacing: 0%;
      border: none;
      cursor: pointer;
    }
    
  }

  .profile-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 32px;
    @media (max-width: 768px) {
      justify-content: flex-end;
    }
  }
  
  .user-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 16px;
    width: auto;
    max-width: 30%;
    
    @media (max-width: 930px) {
      width: 100%;
      max-width: 100%;
    }
  }

  .userData-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    
    .user-info {
      display: flex;
      flex-direction: column;
      min-width: 0;
    }

    .user-txt-wrapper {
      overflow: hidden;
    }

    .img-profile-avanti {
      width: 55px;
      height: 40px;
      padding: 2px;
      transform: rotate(-4.82deg);
      @media (max-width: 930px) {
        width: 50px;
        height: 36px;
      }
    }

    .loyalty-txt {
      font-family: "Roboto";
      font-size: 12px;
      line-height: 18px;
      font-weight: 400;
      color: #e7c394;
      text-transform: capitalize;
      @media (max-width: 930px) {
        font-weight: 400;
        font-size: 10px;
        line-height: 18px;
        letter-spacing: 0%;
      }
    }

    .user-txt {
      font-family: "Roboto";
      font-size: 16px;
      line-height: 18px;
      font-weight: 700;
      color: #ffffff;
      text-transform: uppercase;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      max-width: 100%;

      @media (max-width: 930px) {
        font-size: 12px;
        line-height: 14.06px;
        letter-spacing: 2%;
      }
    }

   .icon-drawer {
    align-self: center;
    .bars-icon {
      width: 21px;
      height: 18px;
      color: #ffffff;
      }
    .close-icon {
       width: 21px;
      height: 18px;
      color: #ffffff;
     }
      @media (max-width: 768px) {
       margin-top: 10px;
      }
    
     @media (min-width: 768px) {
      display: none;
      }
    }

    @media (max-width: 500px) {
      justify-content: flex-start;
      align-items: flex-start;
      display: inline-flex;
      width: 55%;
    }
    @media ((min-width: 501px) and (max-width: 768px)) {
      justify-content: flex-start;
      align-items: flex-start;
      display: inline-flex;
      width: 40%;
    }
    @media ((min-width: 769px) and (max-width: 930px)) {
      justify-content: flex-start;
      align-items: flex-start;
      display: inline-flex;
      width: 30%;
    }
  }

  .quit-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;

    .quit-txt {
      font-family: "Roboto";
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
      color: #ffffff;
      text-transform: capitalize;
      opacity: 0.5;
    }

    .quit-icon {
      width: 16px;
      height: 16px;
      opacity: 0.5;
    }
     
  }
`;

export default Home;
